@if(shouldShowActionButton()){
  <evc-nav-button type="cta" size="xxl" variant="round" (click)="addTitle()" *callToAction>
    <span class="top-cta-label">
      {{ 'commonLayout.newTitle' | translate:{ titleLabel: titleLabel } }}
    </span>
    <evc-svg-icon size="md" icon="plus"></evc-svg-icon>
  </evc-nav-button>
}

<div class="title-menu-area" fxLayout="column" fxLayoutGap="5px" fxLayoutAlign="start end" class="header-fixed">
</div>
<mat-dialog-content>
  <div class="container" fxLayout="column">

    <div class="settings-title-container">
      <h1 [innerHTML]="getTitlesPageTitle()"></h1>
    </div>

    <mat-table mat-table #table [dataSource]="titleListDataSource" class="title-list"
      cdkDropList
      [cdkDropListData]="titleListDataSource"
      (cdkDropListDropped)="dropTable($event)">

      <!-- Title Column -->
      <ng-container matColumnDef="title">
        <mat-header-cell *matHeaderCellDef>{{titleLabel}}</mat-header-cell>
        <mat-cell *matCellDef="let row; let i = index;" cdkDrag [cdkDragData]="row">
          <div fxLayout="row" fxLayoutGap="5px" fxLayoutAlign="start center" style="width: 100%;">
            <div class="title-index-indicator">{{getFormattedTitleIndex(i)}}</div>
            <div class="titles-action-button">
              <mat-icon color="primary" class="table-column-property-panel-draggable titles-action-icon" cdkDragHandle>
                drag_indicator
              </mat-icon>
            </div>
            <mat-form-field class="title-field">
              <input matInput [id]="idPrefix + i" [value]="row.identifier" [(ngModel)]="row.identifier" maxlength="30" (blur)="submit()">
              <mat-hint class="hint-error" align="start" *ngIf="requiredIdentifier(row.identifier)">
                <font color="red">{{ 'settingsTitlesEditDialog.titleError' | translate:{titleLabel: titleLabel} }}</font>
              </mat-hint>
              <mat-hint class="hint-error" align="center" *ngIf="row.identifier?.length > 0 && isRegularTextPattern(row.identifier)">
                <font color="red">&nbsp;{{ 'settingsTitlesEditDialog.titleMessage' | translate:{titleLabel: lowerCaseTitleLabel} }}</font>
              </mat-hint>
              <mat-hint align="end">
                {{ row.identifier?.length || 0 }}/ 30
              </mat-hint>
            </mat-form-field>
            <button mat-button class="titles-action-button" (click)="deleteTitle(i)"
              [disabled]="isDisableDeleteButton(i)">

              <evc-svg-icon size="md" [icon]="'trash-can'"
                            class="black-icon"></evc-svg-icon>
            </button>
          </div>
        </mat-cell>
      </ng-container>

      <mat-row *matRowDef="let row; let index = index; columns: displayedTitleColumns;" (click)="selectTitle(row, index)"
        [class.selected]="isSelectedTitle(row, index)"></mat-row>
    </mat-table>

  </div>
</mat-dialog-content>
